import React, { useState, useEffect } from 'react';
import { Button } from '../../button';
import { Popover, PopoverContent, PopoverTrigger } from '../../popover';
import { X } from 'lucide-react';
import MagnifyingGlass from "../../../assets/icons/magnifying-glass-small-gray.svg";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../select';

interface UserStatusFilterProps {
    filterState: {
        filterKey: string;
        filter: any;
        setFilter: (filters: any) => void;
    };
    title: string;
    description?: string;
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
}

const PopoverUserStatusFilterComponent: React.FC<UserStatusFilterProps> = ({
    filterState,
    title,
    description,
    isOpen,
    onOpenChange
}) => {
    const [localStatus, setLocalStatus] = useState(filterState.filter[filterState.filterKey] || '');

    // Update local state when filter changes
    useEffect(() => {
        setLocalStatus(filterState.filter[filterState.filterKey] || '');
    }, [filterState.filter, filterState.filterKey]);

    const handleStatusChange = (value: string) => {
        const actualValue = value === 'all' ? '' : value;
        setLocalStatus(actualValue);
        filterState.setFilter({
            ...filterState.filter,
            [filterState.filterKey]: actualValue
        });
    };

    const handleClear = () => {
        setLocalStatus('');
        filterState.setFilter({
            ...filterState.filter,
            [filterState.filterKey]: ''
        });
    };

    const hasActiveFilter = localStatus && localStatus.trim() !== '';

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'deactivated', label: 'Deactivated' }
    ];

    return (
        <Popover open={isOpen} onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <img className="ml-2 w-3 cursor-pointer" src={MagnifyingGlass} alt="Search" />
            </PopoverTrigger>
            <PopoverContent className="w-80 p-4" align="start">
                <div className="space-y-4">
                    <div className="flex items-center justify-between">
                        <h4 className="font-medium text-sm">{title}</h4>
                        {hasActiveFilter && (
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={handleClear}
                                className="h-6 px-2 text-xs text-gray-500 hover:text-gray-700"
                            >
                                <X className="h-3 w-3 mr-1" />
                                Clear
                            </Button>
                        )}
                    </div>

                    <div>
                        <Select value={localStatus || 'all'} onValueChange={handleStatusChange}>
                            <SelectTrigger className="w-full">
                                <SelectValue placeholder="Select status..." />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="all">All Status</SelectItem>
                                {statusOptions.map((option) => (
                                    <SelectItem key={option.value} value={option.value}>
                                        {option.label}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>

                </div>
            </PopoverContent>
        </Popover>
    );
};

export default PopoverUserStatusFilterComponent;
